import { ArrowRight } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const ArrowNakedRightIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ArrowRight width={size} height={size} color={color} {...rest} />;

export default ArrowNakedRightIcon;
